/**
 * Build the refund-tag query fragment for the cancel/refund request (GZ#2271).
 *
 * The picker hands back EITHER an existing tag id OR free text the admin typed.
 * Never both — sending both would be ambiguous, and the backend gives the id
 * precedence anyway, so we resolve that here rather than relying on it.
 *
 * Encoding matters: staff type these by hand ("Bad weather", "Coach ill —
 * rescheduled", "Rain & wind"), and an unescaped & or # would silently truncate
 * the reason or corrupt the rest of the query string.
 */
export interface RefundTagSelectionLike {
  tagId: number | null;
  name: string | null;
}

export const buildRefundTagQuery = (
  refundTag?: RefundTagSelectionLike | null
): string => {
  if (!refundTag) return "";

  // An existing tag wins — no point re-resolving a name we already have an id for.
  if (refundTag.tagId) return `&refund_tag_id=${refundTag.tagId}`;

  const name = (refundTag.name || "").trim();
  if (!name) return "";
  return `&refund_tag=${encodeURIComponent(name)}`;
};
